import * as z from "zod";

import { surrealRecordSchema } from "./surreal-record";

export const boardMeetingSectionSchema = surrealRecordSchema.extend({
  name: z.string(),
  index: z.number(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type BoardMeetingSection = z.infer<typeof boardMeetingSectionSchema>;
